import { useMemo, useContext } from 'react';
import { BATTLESHIP, BUTTON_TERTIARY_LIGHT_TEXT, OLAF } from 'HubStyleTokens/colors';
import { CommentableArea } from 'collaboration-sidebar';
import { AppConfigContext } from 'automation-ui-source-apps/context/AppConfigContext';
import { ACTION_MODULE_ID_PREFIX } from 'automation-ui-management/constants/Commenting';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const COMMENTING_ICON_PROPS = {
  color: BUTTON_TERTIARY_LIGHT_TEXT,
  backgroundColor: OLAF,
  borderWidth: 1,
  borderColor: BATTLESHIP,
  padding: 0.3,
  size: 16,
  boxShadow: true
};
const COMMENTING_ICON_POSITION = {
  right: '-15px',
  top: '-15px',
  bottom: 'initial',
  left: 'initial'
};
const CommentBadge = ({
  actionType,
  actionMetadata,
  children,
  nodeId,
  readOnly
}) => {
  const translationKey = useMemo(() => {
    const shouldAdd = 'shouldAdd' in actionMetadata ? actionMetadata.shouldAdd : undefined;
    if (shouldAdd !== undefined) {
      return `${actionType}.${shouldAdd ? 'add' : 'remove'}`;
    }
    return actionType;
  }, [actionMetadata, actionType]);
  const {
    config
  } = useContext(AppConfigContext);
  if (readOnly || !config.shouldAllowCommenting) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  return /*#__PURE__*/_jsx(CommentableArea, {
    iconPosition: COMMENTING_ICON_POSITION,
    iconProps: COMMENTING_ICON_PROPS,
    moduleId: `${ACTION_MODULE_ID_PREFIX}${nodeId}`,
    outlineRadius: 7,
    popoverPlacement: "right",
    showIndicatorsOnHover: true,
    description: {
      translationKey
    },
    children: children
  });
};
export default CommentBadge;